import {
  DATA_TYPE__STRING, DEFAULT_VALUE__CUSTOM,
  FORM_ITEM__EXTERNAL_DATA_SOURCE, FORM_ITEM__TABLE
} from "../types"
import BaseItem from "../BaseItem"

class ExternalDataSource extends BaseItem {
  constructor() {
    super()

    this.value = ''

    this.relateAppId = ''   // 关联的AppId
    this.relateFormId = ''  // 关联的表单Id
    this.relateFieldId = '' // 关联的字段Id
    this.enableLimitCount = 0  // 0 不限制 1 限制最大
    this.limitCount = 100     // 限制个数
    this.chooseType = 0        // 0 单选 1 多选
    this.sortList = [
      {
        fieldId: "",
        sortType: -1, //-1 倒序 1 正序
      }
    ]
    this.filterList = [
      // {
      //   matchType: 0, // 0 具体的值-数字 1 固定的值-文本 2 表单字段
      //   matchStrValue: "",  //匹配文本的值
      //   matchNumValue: 0,
      //   method: "eq", //匹配的方法
      //   localFieldId: "", //本表单字段
      //   remoteFieldId: "" //目标表单字段
      // }
    ]

    this.filterInfo = {
      relation: "and",
      notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: []
    }

    this.relateDataSourceType = 0
    //高级筛选条件 数据的二次筛选
    this.advancedFilter = 0
    this.tableFieldId = ''
    //二次的筛选条件
    this.advancedFilterInfo = {
      relation: "and",
      notJumpEmpty: 1, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: []
    }

    // 给服务器提交id数组，本地构建对象数组
    this.assistFieldIdList = [
      // "fieldId1",
      // "fieldId2"
    ] //辅助显示字段列表
    this.allowAddData = 1 //允许新增数据
    // 联动显示字段
    this.chooseChangeFields = [
      // {
      //   "localFieldId":"当前表单的Id",
      //   "remoteFieldId":"引用表单的Id"
      // }
    ]
    this.defaultValue = {
      defaultType: ''
    }

    this.openUnique = 'OPEN' //OPEN 开启 CLOSE 关闭 null的时候兼容为 OPEN
    this.showNameOnly = 'NO' // 显示人员名称
  }

  get title() {
    return this.fieldTitle || ExternalDataSource._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

ExternalDataSource._title = '数据来源'
ExternalDataSource.use = true
ExternalDataSource.type = FORM_ITEM__EXTERNAL_DATA_SOURCE
ExternalDataSource.icon = 'iconfont icon-jilianxuanze'

ExternalDataSource.prototype.limitCountOptional = [
  {
    label: '不限制',
    value: 0
  },
  {
    label: '限制最大',
    value: 1
  }
]
ExternalDataSource.prototype.chooseTypeOptional = [
  {
    label: '单选',
    value: 0
  },
  {
    label: '多选',
    value: 1
  }
]
ExternalDataSource.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '等于任意一个',
    method: 'in'
  },
  {
    name: '不等于任意一个',
    method: 'nin'
  },
  {
    name: '包含',
    method: 'like'
  },
  {
    name: '不包含',
    method: 'unlike'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
ExternalDataSource.prototype.type = ExternalDataSource.type
ExternalDataSource.prototype.dataType = DATA_TYPE__STRING
ExternalDataSource.prototype.getValue = function () {
  return this.value
}
ExternalDataSource.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val ? String(val) : ''
}
ExternalDataSource.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    defaultValue: this.defaultValue,
    relateAppId: this.relateAppId,
    relateFormId: this.relateFormId,
    relateFieldId: this.relateFieldId,
    enableLimitCount: this.enableLimitCount,
    limitCount: this.limitCount,
    chooseType: this.chooseType,
    sortList: this.sortList,
    filterList: this.filterList,
    filterInfo: this.filterInfo,
    advancedFilter: this.advancedFilter,
    tableFieldId: this.tableFieldId,
    advancedFilterInfo: this.advancedFilterInfo,
    assistFieldIdList: this.assistFieldIdList.map(item => item.fieldId).filter(d => d),
    allowAddData: this.allowAddData,
    relateDataSourceType: this.relateDataSourceType,
    chooseChangeFields: this.chooseChangeFields,
    openUnique: this.openUnique,
    showNameOnly: this.showNameOnly
  }
}
ExternalDataSource.prototype.setConf = function (opts) {
  this.setBase(opts)

  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    }
  }
  if (opts.relateAppId) this.relateAppId = opts.relateAppId
  if (opts.relateFormId) this.relateFormId = opts.relateFormId
  if (opts.relateFieldId) this.relateFieldId = opts.relateFieldId
  if (opts.enableLimitCount) this.enableLimitCount = opts.enableLimitCount
  if (opts.limitCount) this.limitCount = opts.limitCount
  if (opts.chooseType) this.chooseType = opts.chooseType
  if (opts.sortList) this.sortList = opts.sortList
  if (opts.filterList) this.filterList = opts.filterList
  if (opts.filterInfo) this.filterInfo = opts.filterInfo

  if (opts.advancedFilter) this.advancedFilter = opts.advancedFilter
  if (opts.tableFieldId) this.tableFieldId = opts.tableFieldId
  if (opts.advancedFilterInfo) this.advancedFilterInfo = opts.advancedFilterInfo
  if (opts.assistFieldIdList) {
    this.assistFieldIdList = opts.assistFieldIdList.map(fieldId => {
      return {
        fieldId,
        key: Math.random()
      }
    })
  }
  this.relateDataSourceType = opts.relateDataSourceType
  this.allowAddData = opts.allowAddData
  this.chooseChangeFields = opts.chooseChangeFields || []
  this.openUnique = opts.openUnique || 'OPEN'
  this.showNameOnly = opts.showNameOnly || 'NO'
}
ExternalDataSource.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}

export default ExternalDataSource
